import { useRef } from 'react';
import {
  CompanySelect,
  MenuContainer,
  DropdownButton,
  DropDownMenu,
  MenuItem,
  StyledFormGroup,
  CompanyLogo,
  MenuItemLogo,
} from './styled';
import { ReactComponent as LinesIcon } from 'assets/icons/three-lines.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as ChevronIcon } from 'assets/icons/chevron-silver-right.svg';
import { useHistory } from 'react-router-dom';

export const MenuMobile = ({ companies, setOpenMyProfile, openMyProfile, setIsOpen, isOpen }) => {
  const { push } = useHistory();
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const logout = e => {
    e.preventDefault();

    push('/logout');
    return null;
  };
  const openProfile = () => {
    setIsOpen(false);
    setOpenMyProfile(true);
  };
  const goToMainPage = () => {
    setIsOpen(false);
    setOpenMyProfile(false);
  };
  const goToLeankeep = () => {
    window.open(
      `${process.env.REACT_APP_LEGADO}/Anomalias/ShowAnomaliasTablePage.aspx`,
      '_blank',
      'noopener,noreferrer',
    );
  };
  return (
    <MenuContainer>
      {!openMyProfile && (
        <StyledFormGroup label={'Empresa'}>
          <CompanySelect
            size="small"
            hasOnlyUnitsWithSubgroup={true}
            options={companies}
            defaultValue={companies?.length > 1 ? '' : companies?.[0]?.value}
            value={companies?.length > 1 ? '' : companies?.[0]?.value}
            isSearchDisabled={true}
            isClearInputActive={false}
            disabled={false}
          />
        </StyledFormGroup>
      )}
      <DropdownButton onClick={() => setIsOpen(!isOpen)} ref={buttonRef}>
        {isOpen ? <CloseIcon /> : <LinesIcon />}
      </DropdownButton>
      <DropDownMenu isOpen={isOpen} ref={menuRef}>
        <MenuItemLogo>
          <CompanyLogo src={process.env.REACT_APP_URL_IMAGES + `${companies?.[0]?.logo}`} />
        </MenuItemLogo>
        <MenuItem onClick={goToMainPage}>
          inicio <ChevronIcon />
        </MenuItem>
        <MenuItem onClick={goToLeankeep}>
          Acessar versão antiga <ChevronIcon />
        </MenuItem>
        <MenuItem onClick={openProfile}>
          meu perfil <ChevronIcon />
        </MenuItem>
        <MenuItem onClick={e => logout(e)}>
          sair <ChevronIcon />
        </MenuItem>
      </DropDownMenu>
    </MenuContainer>
  );
};
